import { actionTypes } from "../contants/actionTypes";

export const cacheActions = {
    set: (path, data) => ({
        type: actionTypes.setNested,
        payload: { path, data },
    }),
    clear: (path) => ({
        type: actionTypes.clearPath,
        payload: { path },
    }),
    reset: () => ({
        type: actionTypes.resetCache,
    }),
};